import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import './CodeRow.css';

const CodeRow = ({ name, deadline, code, isExpired }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
    } catch (err) {
      console.error('コピー失敗:', err);
    }
  };

  return (
    <div className={`one-line-row ${isExpired ? 'is-expired' : ''}`}>
      {/* 左：名前（はみ出したら自動で「...」にする） */}
      <div className="col-name" title={name}>
        {name}
      </div>

      {/* 中：期限 */}
      <div className="col-date">
        {deadline}
      </div>

      {/* 右：コードとボタンのセット */}
      <div className="col-action">
        <div className="slim-code-box">
          <code>{code}</code>
        </div>
        <button
          onClick={handleCopy}
          className={`slim-copy-btn ${copied ? 'is-copied' : ''}`}
          aria-label="コピー"
        >
          {copied ? <Check size={13} strokeWidth={3} /> : <Copy size={13} />}
        </button>
      </div>
    </div>
  );
};

export default CodeRow;